import axios from "axios";

import { LOGIN, LOGOUT } from "./requestType";
import { host } from "config";

export const getAuthOptionByType = (type, param = {}) => {
  let option = { url: "", method: "" };

  switch (type) {
    case LOGIN:
      option.method = "POST";
      option.url = `${host}/backend/login`;
      option.params = param.qs;
      option.data = param.body;
      break;
    case LOGOUT:
      option.method = "GET";
      option.url = `${host}/backend/logout`;
      break;
    // case FORGET:
    //   option.method = "POST";
    //   option.url = `${host}/user/forget`;
    //   option.data = param.body;
    //   break;
    // case FORGET_RESET:
    //   option.method = "POST";
    //   option.url = `${host}/user/forget/reset/${param.token}/`;
    //   option.data = param.body;
    //   break;
    default:
      return -1;
  }
  return option;
};

export const authProvider = (type, options) => {
  const option = getAuthOptionByType(type, options);
  if (option === -1) throw Error("no match request type");

  const token = localStorage.getItem("JwtToken");
  const headers = {
    "Content-Type": "application/json",
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  return axios({
    ...option,
    headers,
  });
};
